export default __webpack_public_path__ + "img/icon_website_link-4b97a8b741fb89de6c039fb7bd5a3fcf.png";